module.exports = __webpack_public_path__ + "img/1531621083.79628ee8.jpg";